import ContentLoader from 'react-content-loader';
import React from 'react';

const UpcomingPaymentsLoader = () => (
  <ContentLoader
    speed={2}
    height={80}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    style={{ width: '100%', height: '100px' }}
  >
    <rect x="0" y="10" rx="3" ry="3" width="250" height="10" />
    <rect x="20" y="30" rx="3" ry="3" width="220" height="10" />
    <rect x="20" y="50" rx="3" ry="3" width="170" height="10" />
  </ContentLoader>
);

export default UpcomingPaymentsLoader;
